import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/_core/tools/base.component';

@Component({
    selector: 'app-icon-invalid-form-control',
    templateUrl: './icon-invalid-form-control.component.html',
    styleUrls: ['./icon-invalid-form-control.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IconInvalidFormControlComponent extends BaseComponent {

    private _form: AbstractControl;
    private subscription: Subscription = Subscription.EMPTY;

    constructor(protected readonly cdr: ChangeDetectorRef) {
        super(cdr);
    }

    @Input()
    set form(control: AbstractControl) {
        this.subscription.unsubscribe();

        if (control) {
            this.subscription = control.valueChanges.pipe(
                this.untilDestroyed,
                tap(() => this.cdr.markForCheck()),
            ).subscribe();
        }
        this._form = control;
    }

    get form(): AbstractControl {
        return this._form;
    }

    @Input() controlKey: string;
}
